import PropTypes from 'prop-types';
import React from 'react';
import { Button, Collapse, Input } from 'reactstrap';
import MiniLoader from '../../../common/controls/select/miniLoader';
const TvcIssuesProjectRail = _ref => {
  let projectEntries = _ref.projectEntries,
    selectedProjectUuid = _ref.selectedProjectUuid,
    onProjectChange = _ref.onProjectChange,
    onRefreshIssues = _ref.onRefreshIssues,
    loadingIssues = _ref.loadingIssues,
    pendingOperation = _ref.pendingOperation,
    grouped = _ref.grouped,
    expandedAssetTypes = _ref.expandedAssetTypes,
    onToggleAssetType = _ref.onToggleAssetType,
    selectedProjectTitle = _ref.selectedProjectTitle,
    isCheckSelected = _ref.isCheckSelected,
    onSelectCheck = _ref.onSelectCheck;
  const checksTotal = grouped.assetTypes.reduce((sum, a) => sum + a.count, 0);
  return /*#__PURE__*/React.createElement("div", {
    className: "tvc-issues-section__rail"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tvc-issues-section__rail-refresh"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    color: "secondary",
    size: "sm",
    outline: true,
    block: true,
    onClick: onRefreshIssues,
    disabled: !selectedProjectUuid || loadingIssues || pendingOperation
  }, "Refresh")), /*#__PURE__*/React.createElement("div", {
    className: "tvc-issues-section__rail-label"
  }, "Project"), /*#__PURE__*/React.createElement(Input, {
    type: "select",
    value: selectedProjectUuid,
    onChange: onProjectChange,
    className: "tvc-issues-section__project-picker",
    disabled: loadingIssues || pendingOperation
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Select project"), projectEntries.map(p => /*#__PURE__*/React.createElement("option", {
    key: p.mapKey,
    value: p.mapKey
  }, p.title))), loadingIssues ? /*#__PURE__*/React.createElement("div", {
    className: "tvc-issues-section__loading small text-muted mt-1"
  }, /*#__PURE__*/React.createElement(MiniLoader, null)) : null, /*#__PURE__*/React.createElement("div", {
    className: "tvc-issues-section__rail-label tvc-issues-section__checks-label"
  }, "Checks (", checksTotal, ")"), /*#__PURE__*/React.createElement("div", {
    className: "tvc-issues-section__checks"
  }, grouped.assetTypes.map(asset => {
    const isOpen = expandedAssetTypes[asset.name];
    return /*#__PURE__*/React.createElement("div", {
      key: asset.name,
      className: "tvc-issues-section__asset-block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tvc-issues-section__asset-header",
      onClick: () => onToggleAssetType(asset.name),
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggleAssetType(asset.name);
        }
      },
      role: "button",
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("span", {
      className: "tvc-issues-section__asset-title"
    }, asset.name, " (", asset.count, ")"), /*#__PURE__*/React.createElement("span", {
      className: "tvc-issues-section__asset-toggle"
    }, isOpen ? '−' : '+')), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement("div", {
      className: "tvc-issues-section__error-types"
    }, asset.errorTypes.map(err => {
      const selected = isCheckSelected(selectedProjectTitle, asset.name, err.name);
      return /*#__PURE__*/React.createElement("div", {
        key: err.name,
        className: "tvc-issues-section__error-row ".concat(selected ? 'tvc-issues-section__error-row--selected' : ''),
        onClick: e => {
          e.stopPropagation();
          onSelectCheck(selectedProjectTitle, asset.name, err.name);
        },
        onKeyDown: e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            onSelectCheck(selectedProjectTitle, asset.name, err.name);
          }
        },
        role: "button",
        tabIndex: 0
      }, err.name, " (", err.count, ")");
    }))));
  })));
};
const assetTypeShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  errorTypes: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired
  })).isRequired
});
TvcIssuesProjectRail.propTypes = {
  projectEntries: PropTypes.arrayOf(PropTypes.shape({
    mapKey: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired,
  selectedProjectUuid: PropTypes.string.isRequired,
  onProjectChange: PropTypes.func.isRequired,
  onRefreshIssues: PropTypes.func.isRequired,
  loadingIssues: PropTypes.bool.isRequired,
  pendingOperation: PropTypes.bool.isRequired,
  grouped: PropTypes.shape({
    assetTypes: PropTypes.arrayOf(assetTypeShape).isRequired
  }).isRequired,
  expandedAssetTypes: PropTypes.objectOf(PropTypes.bool).isRequired,
  onToggleAssetType: PropTypes.func.isRequired,
  selectedProjectTitle: PropTypes.string.isRequired,
  isCheckSelected: PropTypes.func.isRequired,
  onSelectCheck: PropTypes.func.isRequired
};
export default TvcIssuesProjectRail;